import {File} from './file.interface';

export interface FileState {
  files: Array<File>;
  total: number;
  displayAmt: number;
}
